import parse from "html-react-parser";

function Heading({ txt, hs, hf }) {
  let t = txt && parse(txt);
  return <div style={{ fontSize: `${hs}`, fontFamily: `${hf}` }}>{t}</div>;
}

export default Heading;
